import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ContentType, AttributeType } from './response-types';
import { attributeTypeToContentType } from './jira-search-client';
import uniqBy from 'lodash/uniqBy';
import { generatePeopleProfileUrl } from '../../common/clients/multi-site-utils';
export function transformJiraIssueScope(response, isCached, timings) {
  var results = response.results,
    size = response.size;
  return {
    items: results.filter(function (item) {
      return item.attributes['@type'] === AttributeType.issue;
    }).map(function (item) {
      return {
        resultId: item.id,
        name: item.name,
        href: item.url,
        contentType: ContentType.JiraIssue,
        attributes: _objectSpread(_objectSpread({}, item.attributes), {}, {
          isRecentResult: isCached
        }),
        isCached: isCached
      };
    }),
    timings: timings,
    totalSize: size || results.length
  };
}
export function transformJiraPlanScope(results, isCached, timings) {
  return {
    items: results.map(function (item) {
      return {
        resultId: item.id,
        name: item.name,
        href: item.url,
        contentType: ContentType.JiraPlan,
        attributes: item.attributes,
        isCached: isCached
      };
    }),
    timings: timings,
    totalSize: results.length
  };
}
export function transformJiraBoardProjectFilterScope(results, isCached, timings) {
  return {
    items: results.filter(function (item) {
      return [AttributeType.board, AttributeType.project, AttributeType.filter, AttributeType.plan].includes(item.attributes['@type']);
    }).map(function (item) {
      var contentType = attributeTypeToContentType(item.attributes['@type']);
      return {
        resultId: item.id,
        name: item.name,
        href: item.url,
        contentType: contentType,
        attributes: item.attributes,
        isCached: isCached
      };
    }),
    timings: timings,
    totalSize: results.length
  };
}
export function transformJiraProjectScope(results, isCached, timings) {
  return {
    items: results.map(function (item) {
      return {
        resultId: item.id,
        name: item.name,
        href: item.url,
        contentType: ContentType.JiraProject,
        attributes: item.attributes,
        isCached: isCached
      };
    }),
    timings: timings,
    totalSize: results.length
  };
}
export function transformUrsPeople(results, isCached, timings, isMultiSite) {
  return {
    items: uniqBy(results, function (item) {
      return item.id;
    }).map(function (item) {
      return {
        resultId: item.id,
        name: item.name,
        href: generatePeopleProfileUrl(isMultiSite, item.absoluteUrl, item.id, 'jira'),
        contentType: ContentType.JiraPeople,
        attributes: {
          '@type': AttributeType.people,
          avatarUrl: item.avatarUrl,
          userId: item.id
        },
        isCached: isCached
      };
    }),
    timings: timings,
    totalSize: results.length
  };
}